import NumberFlow, {
  type NumberFlowProps,
  type Format,
} from '@number-flow/react';

interface IAnimatedNumberProps extends NumberFlowProps {
  className?: string;
  /**
   * The duration of the animation in milliseconds.
   */
  duration?: number;
  format?: Format;
  value: number;
}

/**
 * -----------------------------------------------------------------------------
 * AnimatedNumber component for displaying a number with animation starting from
 * zero to a specified value.
 */
export function AnimatedNumber(props: IAnimatedNumberProps) {
  return <NumberFlow {...props} />;
}
